// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ButtonWrapper } from "@eisinc/MobiusOverrides/Button";
import { headerShipToAddressStyles } from "@eisinc/Overrides/Widgets/Common/HeaderShipToAddress";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { color } from "@eisinc/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

headerShipToAddressStyles.shipToAddressWrapper = {
    css: css`
        display: inline-flex;
        width: 100%;
        gap: 4px;
        align-items: center;
        height: 30px;
    `,
};

headerShipToAddressStyles.titleClickable = {
    css: css`
        margin-left: 10px;
        width: calc(100% - 10px);
        padding: 6px 0;
    `,
};

headerShipToAddressStyles.titleIcon = {
    size: 17,
    css: css`
        width: 14px;
        margin-bottom: 2px;
    `,
};

headerShipToAddressStyles.titleTypography = {
    css: css`
        margin-left: 4px;
    `,
    ellipsis: true,
    transform: "capitalize",
};

headerShipToAddressStyles.shipToSelector = {
    cssOverrides: {
        wrapper: css`
            width: 100%;
            height: auto;

            ${ButtonWrapper} {
                width: 100%;
                background: transparent;
                height: 30px;
                min-height: 30px;
                border: none;
                min-width: 175px;
                ${TypographyStyle} {
                    color: ${color("text.main")};
                }
                &:focus {
                    ${TypographyStyle} {
                        color: ${color("text.main")};
                    }
                }
            }
        `,
        menu: css`
            width: auto;
            max-width: 90%;
            background: ${color("common.ui3")};
            border-top: 1px solid ${color("primary.main")};
            border-radius: 8px;
            left: auto !important;
        `,
    },
};

headerShipToAddressStyles.iconWrapper = {
    css: css`
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: flex-end;
        gap: 4px;
        padding: 0;
        outline: 2px solid transparent;
        ${({ isOpen }: any) =>
            isOpen &&
            css`
                outline-color: ${color("common.border")};
            `}
    `,
};

headerShipToAddressStyles.fulfillmentText = {
    ...fontConfig.singleLineSmall,
};

headerShipToAddressStyles.arrowIcon = {
    size: 15,
    css: css`
        ${({ isOpen }: any) =>
            isOpen &&
            css`
                transform: rotate(180deg);
            `}
    `,
};

headerShipToAddressStyles.fulfillmentWrapper = {
    css: css`
        display: flex;
        gap: 8px;
        align-items: center;
        padding: 4px 8px;
    `,
};

headerShipToAddressStyles.fulfillmentLink = {
    css: css`
        && {
            width: max-content;
            padding: 0;
            white-space: nowrap;
            &:hover {
                background: transparent;
            }
            ${TypographyStyle} {
                padding: 0;
                &:hover {
                    background: transparent;
                }
            }
        }
    `,
};

const baseDrawerStyles = {
    closeButtonProps: {
        shape: "pill" as const,
        buttonType: "solid" as const,
        color: "common.background",
        size: 36,
    },
    closeButtonIconProps: {
        src: "X" as const,
        size: 24,
        color: "text",
        css: css` 
            &&&& {
                color: ${color("text")};
                &:hover, &:focus {
                    color: ${color("common.ui8")}
                };
            }         
        `
        ,
    },
    cssOverrides: {
        drawerContent: css`
            height: 100%;
            overflow-y: inherit;
        `,
        drawerBody: css`
            background: ${getColor("common.background")};
            height: auto;
            max-height: 500px;
            overflow-x: inherit;
            overflow-y: inherit;
            top: 50%;
            transform: translateY(-50%);
            padding: 0 50px 20px 50px;
            min-height: 260px;
        `,
        drawerTitle: css`
            background: ${getColor("common.background")};
        `,
    },
    headlineTypographyProps: {
        color: "text.main",
    },
};

headerShipToAddressStyles.drawer = baseDrawerStyles;

headerShipToAddressStyles.drawerInShell = {
    ...baseDrawerStyles,
    cssOverrides: {
        ...baseDrawerStyles.cssOverrides,
        drawerBody: css`
            background: ${getColor("common.background")};
            height: auto;
            overflow-x: inherit;
            overflow-y: inherit;
        `,
    },
};

headerShipToAddressStyles.drawerInPunchOut = {
    ...baseDrawerStyles,
    cssOverrides: {
        ...baseDrawerStyles.cssOverrides,
        drawerBody: css`
            background: ${getColor("common.background")};
            overflow-x: inherit;
            overflow-y: show;
        `,
    },
};
